import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import config from '../../../envConfig';
import { selectCarteiraDocumentos, limparErro } from '../carteiraDocumentosSlice';
import { useUploadCordova } from './useUploadCordova';
import { useUploadWeb } from './useUploadWeb';
import AlertaModal from '../Components/AlertaModal';
import styles from './UploadDocumento.module.css';

const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const UploadDocumento: React.FC = () => {
  const dados = useAppSelector(selectCarteiraDocumentos);
  const dispatch = useAppDispatch();
  const isCordova = config.isCordova && !!window.cordova;

  const cordova = useUploadCordova();
  const web = useUploadWeb();

  const loading = isCordova ? cordova.loading : false;
  const handleSelecionarGaleria = isCordova ? cordova.handleSelecionarGaleria : web.handleSelecionarGaleria;
  const handleTirarFoto = isCordova ? cordova.handleTirarFoto : web.handleTirarFoto;
  const erroAlerta = dados.erroInclusao || (isCordova ? cordova.erroAlerta : web.erroAlerta);
  const limparErroAlerta = dados.erroInclusao
    ? () => dispatch(limparErro())
    : (isCordova ? cordova.limparErroAlerta : web.limparErroAlerta);
  return (
    <div className={styles.container}>
      {erroAlerta && (
        <AlertaModal mensagem={erroAlerta} onClose={limparErroAlerta} />
      )}
      <div className={styles.header}>
        <h2 className={styles.integranteNome}>{dados.integranteNome}</h2>
        <p className={styles.tipoDocumento}>{dados.nomeDocumento}</p>
      </div>

      <div className={styles.opcoesContainer}>
        <button
          className={`${styles.opcaoButton} ${loading ? styles.opcaoButtonDisabled : ''}`}
          onClick={handleSelecionarGaleria}
          disabled={loading}
        >
          <div className={styles.opcaoIcon}>
            <i className={loading ? 'fas fa-spinner fa-spin' : 'fas fa-images'}></i>
          </div>
          <div className={styles.opcaoContent}>
            <span className={styles.opcaoTitulo}>Selecionar da galeria</span>
            <span className={styles.opcaoSubtitulo}>Selecione fotos em formato PNG, JPG ou JPEG de até 2 MB</span>
          </div>
        </button>

        {(isCordova || isMobileDevice) && (
          <button
            className={`${styles.opcaoButton} ${loading ? styles.opcaoButtonDisabled : ''}`}
            onClick={handleTirarFoto}
            disabled={loading}
          >
            <div className={styles.opcaoIcon}>
              <i className={loading ? 'fas fa-spinner fa-spin' : 'fas fa-camera'}></i>
            </div>
            <div className={styles.opcaoContent}>
              <span className={styles.opcaoTitulo}>Tirar foto do documento</span>
              <span className={styles.opcaoSubtitulo}>Use a câmera do seu celular para enviar fotos de até 2MB</span>
            </div>
          </button>
        )}
      </div>

      {!isCordova && (
        <input
          ref={web.fileInputRef}
          type="file"
          style={{ display: 'none' }}
          onChange={web.handleFileChange}
        />
      )}
    </div>
  );
};

export default UploadDocumento;
